<template>
  <StatCard
    :icon="require(`@/assets/images/icon-balance.svg`)"
    :loading="balanceLoading"
    :error="balanceErrorMessage"
    @retry="fetchBalance"
  >
    <template #head>
      <div class="d-flex flex-column align-items-center">
        <p class="m-0">
          {{ $t('dashboard.statistics.billing.balance.title') }}
        </p>
        <h3 class="m-0">{{ balance.balance }} {{ balance.currency }}</h3>
      </div>
    </template>
    <template #foot>
      <div class="text-center">
        <router-link :to="{ name: 'billing-refill' }">
          {{ $t('dashboard.statistics.billing.balance.foot-title') }}
        </router-link>
      </div>
    </template>
  </StatCard>
</template>
<script>
import StatCard from '../../elements/StatCard.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    StatCard
  },
  computed: {
    ...mapGetters(['balance', 'balanceLoading', 'balanceErrorMessage'])
  },
  methods: {
    ...mapActions(['fetchBalance'])
  },
  mounted() {
    this.fetchBalance()
  }
}
</script>
<style lang="scss" scoped></style>
